// const digitPeriodRegExp = /\d|\./

export function blockInvalidChar (event) {
  if (event.ctrlKey || event.altKey || typeof event.key !== 'string' || event.key.length !== 1) {
    return
  }

  if (!/[\d.]/.test(event.key)) {
    event.preventDefault()
    return
  }

  if (event.key === '.' && event.target.value.includes('.')) {
    event.preventDefault()
  }
}

export const blockInvalidCharInInputNumberField = e => {
  ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
}
const lastSent = {}

export const sendMessageOutsideIframe = (eventName, data = null) => {
  const key = JSON.stringify({ eventName, data })
  console.log('eventName:--------->> ', eventName, data)
  if (lastSent[eventName] === key) return

  lastSent[eventName] = key

  if ('requestIdleCallback' in window) {
    requestIdleCallback?.(() => {
      window.parent.postMessage({ eventName, data }, '*')
    })
  } else {
    setTimeout(() => {
      window.parent.postMessage({ eventName, data }, '*')
    }, 16)
  }
}
